const stable = (value) => {
  try {
    return JSON.stringify(value);
  } catch (error) {
    return '';
  }
};

const SECTIONS = ['nodes', 'edges', 'flows'];

export const diffCollection = (prev, next) => {
  const prevList = Array.isArray(prev) ? prev : [];
  const nextList = Array.isArray(next) ? next : [];
  const prevById = new Map(prevList.map((item) => [item?.id, item]));
  const nextIds = new Set(nextList.map((item) => item?.id));

  const upsert = nextList.filter((item) => {
    const previous = prevById.get(item?.id);
    return !previous || stable(previous) !== stable(item);
  });

  const remove = prevList
    .map((item) => item?.id)
    .filter((id) => id !== undefined && id !== null && !nextIds.has(id));

  return { upsert, remove };
};

export const buildGraphDiff = (prev, next) =>
  SECTIONS.reduce((acc, section) => {
    acc[section] = diffCollection(prev?.[section], next?.[section]);
    return acc;
  }, {});

export const diffIsEmpty = (diff) =>
  SECTIONS.every(
    (section) =>
      !diff?.[section]?.upsert?.length && !diff?.[section]?.remove?.length
  );

export const diffRatio = (diff, next) => {
  const changed = SECTIONS.reduce(
    (acc, section) =>
      acc +
      (diff?.[section]?.upsert?.length || 0) +
      (diff?.[section]?.remove?.length || 0),
    0
  );
  const total =
    SECTIONS.reduce(
      (acc, section) => acc + (next?.[section]?.length || 0),
      0
    ) || 1;
  return changed / total;
};

export const graphSnapshot = (source) =>
  SECTIONS.reduce((acc, section) => {
    acc[section] = Array.isArray(source?.[section])
      ? source[section].map((item) => item)
      : [];
    return acc;
  }, {});
